let ColorFormatter = function(annotation) {
    var highlightBody = annotation.bodies.find(function(b) {
        return b.purpose == 'highlighting';
    });

    if(highlightBody?.value[0] === '#'){
        try {
            let el = document.querySelector(`[data-id="${annotation.underlying.id}"] .a9s-outer`);
            let elInner = document.querySelector(`[data-id="${annotation.underlying.id}"] .a9s-inner`);

            if(!el && !elInner){
                el = document.querySelector(`.a9s-annotation.editable.selected .a9s-outer`);
                elInner = document.querySelector(`.a9s-annotation.editable.selected .a9s-inner`);
            }

            el.style.stroke = highlightBody.value
            el.style.strokeWidth = '3px'
            el.style.fill = `${highlightBody.value}30`

            elInner.style.stroke = 'none'
            elInner.style.fill = 'transparent'



        } catch (error) {

        }
    }

    if (highlightBody)

        return highlightBody.value;
}

export default ColorFormatter
